module.exports = __webpack_public_path__ + "fonts/alfont_com_AAJannatLT-.32a278b.ttf";